import { z } from 'zod';
import { FormField } from '../../../dynamic-form.types';

export const buildNumberFieldSchema = (field: FormField) => {
  const isRequired = field.rules.required?.value ?? false;
  const errorMessage = field.rules.required?.copy ?? 'Required';

  if (isRequired) {
    return z.preprocess(
      (val) => {
        if (val === '' || val === null || val === undefined) {
          return undefined;
        }
        const parsed = Number(val);
        return isNaN(parsed) ? NaN : parsed;
      },
      z
        .number({
          required_error: errorMessage,
          invalid_type_error: errorMessage,
        })
        .refine((v) => !isNaN(v), { message: errorMessage })
    );
  }

  return z.preprocess((val) => {
    if (val === '' || val === null || val === undefined) {
      return undefined;
    }
    const parsed = Number(val);
    return isNaN(parsed) ? NaN : parsed;
  }, z.number().optional());
};
